import { PHeading, PText } from "@porsche-design-system/components-react"
import type { CustomerFeedbackItem as FeedbackItem } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import { Modal } from "src/context/modal/Modal"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { CustomerFeedbackItem } from "./CustomerFeedbackItem"
import { customerFeedbackMessages } from "./customerFeedback.messages"

export interface CustomerFeedbackModalProps {
	feedback: FeedbackItem[]
	title: string
}

type Props = ModalProps<CustomerFeedbackModalProps>

export const CustomerFeedbackModal = ({ id, modalProps }: Props) => {
	const { feedback, title } = modalProps

	return (
		<Modal id={id}>
			<PText size="sm" color="contrast-high" slot="header">
				{title}
			</PText>
			<PHeading size="lg" tag="h2" slot="header">
				<FormattedMessage {...customerFeedbackMessages.headline} />
			</PHeading>
			{feedback.map((item, i) => (
				<CustomerFeedbackItem key={i} {...item} />
			))}
		</Modal>
	)
}
